var map = {
	"./0312.png": 2665,
	"./0578.png": 7526,
	"./0784.png": 7660,
	"./0944.png": 8491,
	"./A-2.svg": 9756,
	"./Babbo.mp4": 2469,
	"./BabboOld.mp4": 8810,
	"./Senza_titolo-1.svg": 1117,
	"./advertising1.jpg": 5602,
	"./advertising3.jpg": 156,
	"./advertising4.jpg": 1937,
	"./advertising5.jpeg": 3452,
	"./advertising5.jpg": 8965,
	"./amore.jpg": 789,
	"./cloud1.png": 9737,
	"./cloud2.png": 2473,
	"./cloud3.png": 3257,
	"./enjoy.png": 1170,
	"./esagoni.png": 2,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./logo_old.svg": 7083,
	"./mountBg.png": 2914,
	"./mountFg.png": 656,
	"./mountMg.png": 1862,
	"./portanuova.mp4": 8580,
	"./portanuova/IMG_0069.jpg": 447,
	"./portanuova/IMG_0070.jpg": 6857,
	"./portanuova/IMG_0071.jpg": 6825,
	"./portanuova/IMG_0072.jpg": 6151,
	"./portanuova/IMG_0073.jpg": 6836,
	"./portanuova/IMG_0074.jpg": 5440,
	"./portanuova/IMG_0075.jpg": 1981,
	"./produzione1.jpg": 2625,
	"./produzione2.jpg": 5869,
	"./produzione3.jpeg": 5657,
	"./produzione3.jpg": 7727,
	"./progettazione1.jpeg": 7530,
	"./progettazione1.jpg": 7101,
	"./progettazione2.jpeg": 6419,
	"./progettazione2.jpg": 6870,
	"./right-arrow.png": 7898,
	"./sky.jpg": 7295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;